import { render, staticRenderFns } from "./InputUpload.vue?vue&type=template&id=fdef3a92&scoped=true&"
import script from "./InputUpload.vue?vue&type=script&lang=js&"
export * from "./InputUpload.vue?vue&type=script&lang=js&"
import style0 from "./InputUpload.vue?vue&type=style&index=0&id=fdef3a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdef3a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdef3a92')) {
      api.createRecord('fdef3a92', component.options)
    } else {
      api.reload('fdef3a92', component.options)
    }
    module.hot.accept("./InputUpload.vue?vue&type=template&id=fdef3a92&scoped=true&", function () {
      api.rerender('fdef3a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InputUpload.vue"
export default component.exports